<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Order List </h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="mb-3">Filter by</h5>
                        <a-form :form="form"  @submit="searchHandel">
                            <div class="row">
                                <div class="col-md-3">
                                    <a-form-item label="Order Id">
                                        <a-input size="large"
                                            v-decorator="['unique_id', { rules: [{ required: false }] }]"
                                            placeholder="Search by orderID"
                                        />
                                    </a-form-item>
                                </div>
                                
                                <div class="col-md-3">
                                    <a-form-item label="Order Status">
                                        <a-select size="large"
                                            show-search
                                            :filter-option="filterOption"
                                            v-decorator="[ 'order_status_id',
                                                { rules: [{ required: false}] },
                                            ]"
                                            placeholder="Search by order status"
                                        >
                                            <template v-for="status in orderStatusList">
                                                <a-select-option :key="status.id" :value="status.id">
                                                    {{status.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div class="col-md-3">
                                    <a-form-item label="Area">
                                        <a-select size="large"
                                            show-search
                                            :allowClear="false"
                                            @change="handleChangeArea"
                                            :filter-option="filterOption"
                                            v-decorator="[ 'area_id', { rules: [{ required: false }] }]"
                                            placeholder="Search by area"
                                        >
                                            <template v-for="area in areas">
                                                <a-select-option :key="area.id" :value="area.id">
                                                    {{area.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>                                

                                <div class="mb-4 col-md-3">
                                    <a-form-item label="Hub">
                                        <a-select size="large"
                                            show-search
                                            :allowClear="false"
                                            @change="handleChangeHub"
                                            :filter-option="filterOption"
                                            v-decorator="[ 'hub_id', { rules: [{ required: false }] }]"
                                            placeholder="Search by hub"
                                        >
                                            <template v-for="hub in hubs">
                                                <a-select-option :key="hub.id" :value="hub.id">
                                                    {{hub.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div class="mb-4 col-md-3">
                                    <a-form-item label="Zone">
                                        <a-select size="large"
                                            show-search
                                            :allowClear="false"
                                            :filter-option="filterOption"
                                            v-decorator="[ 'zone_id', { rules: [{ required: false }] }]"
                                            placeholder="Search by zone"
                                        >
                                            <template v-for="zone in zones">
                                                <a-select-option :key="zone.id" :value="zone.id">
                                                    {{zone.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div class="mb-4 col-md-3">
                                    <a-form-item label="Delivery Schedule">
                                        <a-select size="large"
                                            show-search
                                            :allowClear="false"
                                            :filter-option="filterOption"
                                            v-decorator="[ 'delivery_schedule', { rules: [{ required: false }] }]"
                                            placeholder="Search by delivery schedule"
                                        >
                                            <template v-for="sidule in delivarySiduleList">
                                                <a-select-option :key="sidule.id" :value="sidule.value">
                                                    {{sidule.value}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div class="mb-4 col-md-3">
                                    <a-form-item label="Payment Type">
                                        <a-select size="large"
                                            show-search
                                            :allowClear="false"
                                            :filter-option="filterOption"
                                            v-decorator="[ 'payment_type', { rules: [{ required: false }] }]"
                                            placeholder="Search by payment type"
                                        >
                                            <a-select-option key="1" value="SSLCOMMERZ">
                                                SSLCOMMERZ
                                            </a-select-option>
                                            <a-select-option key="2" value="COD">
                                                COD
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </div>

                                <div class="col-md-3">
                                    <a-form-item label="Order Date">
                                        <a-range-picker size="large" :allowClear="false"
                                            v-decorator="[ 'date',
                                                { rules: [{ required: false}] },
                                            ]">
                                            <template slot="renderExtraFooter">
                                                extra footer
                                            </template>
                                        </a-range-picker>
                                    </a-form-item>
                                </div>

                                <div class="col-md-12">
                                    <a-button class="px-5" type="danger" size="large" @click="exportReport">
                                        Export
                                    </a-button>
                                    <span class="float-right">
                                        <a-button type="primary" class="btn btn-secondary rounded font-md mr-2" size="large" @click="resetFilter">
                                            Reset
                                        </a-button>
                                        <a-button type="primary" class="btn btn-xs rounded font-md" size="large" html-type="submit">
                                            Filter
                                        </a-button>
                                    </span>
                                </div> 
                            </div>
                        </a-form>
                    </div>
                </div> <!-- card end// -->
            </div>
            <div class="col-md-12">
                <a-card >
                    <a-table
                        :columns="columns"
                        :data-source="orders"
                        :pagination="{
                            current: currentPage,
                            total: pageCount * 10,
                            onChange: (page) => paginate(page),
                        }"
                        :scroll="{x: 'calc(1200px + 50%)', y: 900 }"
                    > <!-- x: 'calc(600px + 50%)', -->
                        <span slot="order_id" slot-scope="text, record">
                            <router-link :to="'/order-deatils/'+ record.id" type="primary" size="small">
                                {{record.unique_id}}
                            </router-link>
                        </span>
                        
                        <span slot="status" slot-scope="text, record">
                            {{record.status ? 'Active' : 'Inactive'}}
                        </span>

                        <span slot="customer-address" slot-scope="text, record">
                            <div v-html="showAddress(record)"></div>
                        </span>

                        <span slot="quantity" slot-scope="text, record">
                            {{record.details.length || 0}}
                        </span>

                        <span slot="action" slot-scope="text, record">
                            <router-link :to="'/order-deatils/'+ record.id" type="primary" class="btn btn-xs" size="small">
                                Details
                            </router-link>
                        </span>
                    </a-table>
                </a-card>
            </div>
        </div>
    </div>
</template>


<script>
    import { ORDER_LIST, ORDER_STATUS_LIST, AREA_LIST, ZONE_LIST, HUB_LIST, DELIVARY_SCHEDULE_LIST, ORDER_LIST_EXPORT } from "../../../script/api";
    import { getData } from "../../../script/api-service";
    import {buildSearchQuery} from "../../../script/helper";
    import moment from "moment";

    const columns = [
        {
            title: 'Order ID',
            // dataIndex: 'unique_id',
            scopedSlots: { customRender: 'order_id' }
        },
        {
            title: 'Picking Date',
            dataIndex: 'picking_date',
        },
        {
            title: 'Delivery Date',
            dataIndex: 'delivery_date',
        },
        {
            title: 'Order Date',
            dataIndex: 'order_date',
        },
        {
            title: 'Address',
            dataIndex: 'customer_address',
            width: 160,
            scopedSlots: { customRender: 'customer-address' }
        },
        {
            title: 'Item',
            scopedSlots: { customRender: 'quantity' }
        },
        {
            title: 'Hub',
            dataIndex: 'hub.name',
        },
        {
            title: 'Delivary Schedule',
            dataIndex: 'delivery_schedule',
            width: "170px"
        },
        {
            title: 'Payment Type',
            dataIndex: 'payment_type',
            width: "140px"
        },
        {
            title: 'Price',
            dataIndex: "total"
        },
        {
            title: 'Consumer Name',
            dataIndex: 'customer.name',
            width: "150px"
        },
        {
            title: 'Consumer Mobile',
            dataIndex: 'customer.mobile',
        },
        {
            title: 'Order Status',
            dataIndex: 'order_status.name'       
        },
        {
            title: 'Action',
            key: 'action',
            fixed: "right",
            scopedSlots: { customRender: 'action' },
        }
    ];

export default {
    data() {
        return {
            columns,
            orders: [],
            search: null,
            form: this.$form.createForm(this, { name: 'searchDivision' }),
            orderStatusList: [],
            currentPage: 1, 
            pageCount: 0,
            areas: [],
            zones: [],
            hubs: [],
            delivarySiduleList: [],
            zoneFilter: {}
        };
    },
    watch: {
        search: function (newVal, oldVal) {
            if (newVal || (!newVal && oldVal)) {
                this.getOrderList(newVal);
            }
        },
    },
    methods: {
        async getOrderList(query) {
            let url = ORDER_LIST + '?';

            if (query) url = url + query;
            if (this.currentPage) url = url + `&page=${this.currentPage}`;

            let res = await getData(url);

            if (res) {
                let masterData = res.data?.data;
                this.orders = masterData.data || [];
                this.pageCount = masterData.paginator.total_pages;
            }
        },
        async getOrderStatusList() {
            let res = await getData(ORDER_STATUS_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.orderStatusList = masterData;
            }
        },
        showAddress(data) {
            if (data?.customer?.others?.length && data.customer.others[0].note) {
                return `<span>${data.customer.others[0].note}</span> <br> ${data.customer.address}`;
            } else return data?.customer?.address;
        },
        searchHandel(e) {
            e.preventDefault();
            this.form.validateFields( async(err, values) => {
                if (!err) {
                    if (values?.date?.length) {
                        values.from_date = moment(values.date[0]._d).format('YYYY-MM-DD');
                        values.to_date = moment(values.date[1]._d).format('YYYY-MM-DD');

                        delete values.date;
                    }
                    this.search = buildSearchQuery(values);
                    this.currentPage = 1;
                }
            })
        },
        resetFilter() {
            this.form.resetFields();
            this.search = '';
            this.currentPage = 1;
            this.zoneFilter = {};
        },
        paginate(page) {
            this.currentPage = page;
            this.getOrderList(this.search);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        async getAreas() {
            let res = await getData(AREA_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.areas = masterData;
            }
        },
        async getZones() {
            let url = ZONE_LIST + '?';

            if (this.zoneFilter) {
                if (this.zoneFilter.area_id) url = url + "&area_id=" + this.zoneFilter.area_id;
                if (this.zoneFilter.hub_id) url = url + "&hub_id=" + this.zoneFilter.hub_id;
            }

            let res = await getData(url);

            if (res) {
                let masterData = res.data?.data;
                this.zones = masterData || [];
            }
        },
        async getHubs() {
            let res = await getData(HUB_LIST + '?status=1');

            if (res) {
                let masterData = res.data?.data;
                this.hubs = masterData || [];
            }
        },
        async getDelivarySiduleList() {
            let res = await getData(DELIVARY_SCHEDULE_LIST);

            if (res) {
                this.delivarySiduleList = res.data.data.schedules;
            }
        },
        async exportReport() {
            // console.log("this.search", this.search); &from_date=2022-04-01&to_date=2022-04-30
            // console.log("hti", this.form.getFieldsValue());
            let values = this.form.getFieldsValue();
            if (values?.date && values?.date?.length) {
                values.from_date = moment(values.date[0]).format("YYYY-MM-DD");
                values.to_date = moment(values.date[1]).format("YYYY-MM-DD");
            }
            let str = buildSearchQuery(values);

            console.log("str==", str);
            
            let url = ORDER_LIST_EXPORT + '?';
            if (str) url = url + str;
            let api_link = process.env.VUE_APP_BASEURL;
            
            let baseURL = api_link + url;
            window.open(baseURL, '_blank');
        },
        handleChangeArea(value) {
            this.zoneFilter['area_id'] = value;
            this.getZones();
            this.form.resetFields("zone_id");
        },
        handleChangeHub(value) {
            this.zoneFilter['hub_id'] = value;
            this.getZones()
            this.form.resetFields("zone_id");
        }
    },
    mounted() {
        this.getOrderList();
        this.getOrderStatusList();
        this.getAreas();
        this.getZones();
        this.getHubs();
        this.getDelivarySiduleList()
    },
};
</script>